import { Pipe, PipeTransform } from '@angular/core';
import { DateFormat } from '../utils/date-format';

@Pipe({
  name: 'expirationDate'
})
export class ExpirationDatePipe implements PipeTransform {
  constructor(private dateFormat: DateFormat) {}
  transform(value: any): any {
    if (!value || value === '') {
      return '';
    }

    try {
      const date = new Date(value);

      if (
        date.getDate() === 31 &&
        date.getFullYear() === 2999 &&
        date.getMonth() === 11
      ) {
        return '';
      }

      return this.dateFormat.format(date, 'MM/dd/yyyy');
    } catch {
      return '';
    }
  }
}
